export {default as chord} from "./src/chord";
export {default as ribbon} from "./src/ribbon";



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-chord/index.js
// module id = ../../../../d3-chord/index.js
// module chunks = 4